export const MAXAGE = 100;
export const MINAGE = 18;
export const AVERAGE_AGE = 30;
